import { Component, Input } from '@angular/core';

import { CompanyService }       from '../companies/company.service';
import { CustomerSourceModel }  from './typings/customer-source';
import { PaymentMethodModel }   from './typings/payment-method';
import { ProductCategoryModel } from './typings/product-category';
import { ProductGroupModel }    from './typings/product-group';
import { TemplateModel }        from '../templates/typings/template';

@Component({
  selector   : 'wor-company-lists',
  template: require('./company-lists.component.html')
})
export class CompanyListsComponent {
  @Input() customerSources     : Array<CustomerSourceModel>  = [];
  @Input() documentTemplates   : Array<TemplateModel>        = [];
  @Input() emailTemplates      : Array<TemplateModel>        = [];
  @Input() invoiceNoteTemplates: Array<TemplateModel>        = [];
  @Input() jobCardTemplates    : Array<TemplateModel>        = [];
  @Input() paymentMethods      : Array<PaymentMethodModel>   = [];
  @Input() productCategories   : Array<ProductCategoryModel> = [];
  @Input() productGroups       : Array<ProductGroupModel>    = [];
  @Input() smsTemplates        : Array<TemplateModel>        = [];
  @Input() unitForSaleTemplates: Array<TemplateModel>        = [];

  constructor (
    public companyService: CompanyService
  ) {}
}
